import React, { useState } from "react";
import { API_BASE } from "../utils/apiBase";

export default function ContactPage({ onGoBack }) {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "", website: "" });
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const updateField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("");
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data?.detail || "Unable to send your message right now.");
      }
      setForm({ name: "", email: "", subject: "", message: "", website: "" });
      setStatus("Thanks - your message has been sent to GearCheckAuto support.");
    } catch (err) {
      setError(err?.message || "Unable to send your message right now.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-gray-900 px-4 py-10 text-slate-900 dark:text-gray-100">
      <div className="mx-auto max-w-2xl rounded-2xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-6 shadow-sm md:p-8">
        <button type="button" onClick={onGoBack} className="mb-6 text-sm font-semibold text-blue-700 dark:text-blue-300 hover:text-blue-600">
          ← Back to GearCheckAuto
        </button>
        <h1 className="text-3xl font-bold text-blue-700 dark:text-blue-300">Contact us</h1>
        <p className="mt-3 text-slate-600 dark:text-gray-300">
          Have a question or need help? Send us a note and we’ll route it to GearCheckAuto support.
        </p>

        {status ? <div className="mt-6 rounded-lg border border-green-200 dark:border-green-900 bg-green-50 dark:bg-green-950/40 p-3 text-sm text-green-800 dark:text-green-300">{status}</div> : null}
        {error ? <div className="mt-6 rounded-lg border border-red-200 dark:border-red-900 bg-red-50 dark:bg-red-950/40 p-3 text-sm text-red-800 dark:text-red-300">{error}</div> : null}

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label htmlFor="contact-name" className="block text-sm font-medium text-slate-700 dark:text-gray-200">Name</label>
            <input
              id="contact-name"
              type="text"
              value={form.name}
              onChange={(event) => updateField("name", event.target.value)}
              maxLength={120}
              required
              className="mt-1 w-full rounded-lg border border-slate-300 dark:border-gray-600 px-3 py-2 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <div>
            <label htmlFor="contact-email" className="block text-sm font-medium text-slate-700 dark:text-gray-200">Email</label>
            <input
              id="contact-email"
              type="email"
              value={form.email}
              onChange={(event) => updateField("email", event.target.value)}
              required
              className="mt-1 w-full rounded-lg border border-slate-300 dark:border-gray-600 px-3 py-2 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <div>
            <label htmlFor="contact-subject" className="block text-sm font-medium text-slate-700 dark:text-gray-200">Subject</label>
            <input
              id="contact-subject"
              type="text"
              value={form.subject}
              onChange={(event) => updateField("subject", event.target.value)}
              maxLength={160}
              required
              className="mt-1 w-full rounded-lg border border-slate-300 dark:border-gray-600 px-3 py-2 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <div>
            <label htmlFor="contact-message" className="block text-sm font-medium text-slate-700 dark:text-gray-200">Message</label>
            <textarea
              id="contact-message"
              value={form.message}
              onChange={(event) => updateField("message", event.target.value)}
              minLength={10}
              maxLength={4000}
              required
              rows={6}
              className="mt-1 w-full rounded-lg border border-slate-300 dark:border-gray-600 px-3 py-2 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <div className="hidden" aria-hidden="true">
            <label htmlFor="contact-website">Website</label>
            <input
              id="contact-website"
              type="text"
              tabIndex={-1}
              autoComplete="off"
              value={form.website}
              onChange={(event) => updateField("website", event.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-blue-700 px-5 py-3 font-semibold text-white hover:bg-blue-600 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {loading ? "Sending..." : "Send message"}
          </button>
        </form>
      </div>
    </div>
  );
}
